import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import BreadcrumbItem from '../../../commonComponents/breadcrumb/breadcrumbItem';
import './breadcrumbs.scss';

const {
  breadcrumbGenderCategory,
  breadcrumbGenderCategoryUrl,
  breadcrumbSilhouetteCategory,
  breadcrumbSilhouetteCategoryUrl,
} = window.inlinePlp;

const { locale } = window.inlineGlobalConfig;

const genderMap = {
  FEMALE: 'women',
  MALE: 'men',
  KIDS: 'kids',
};

const BreadCrumbs = () => {
  const intl = useIntl();

  const genderMessageIntlFormatted = intl.formatMessage({
    id: `subscription.page.gender.${genderMap?.[breadcrumbGenderCategory]}`,
  });

  return (
    <div className="breadcrumbs-container">
      <ol className="breadcrumbs" itemScope itemType="http://schema.org/BreadcrumbList">
        <li className="breadcrumbs__item" itemProp="itemListElement" itemScope itemType="http://schema.org/ListItem">
          <a className="js-tracking-breadcrumbs" itemProp="item" href={`/${locale.country}/${locale.language}/`}>
            <span itemProp="name">
              <FormattedMessage id="breadcrumb.root" description="Home" />
            </span>
          </a>
          <meta itemProp="position" content="1" />
        </li>
        {breadcrumbGenderCategory && breadcrumbGenderCategoryUrl && (
          <BreadcrumbItem
            url={`/${locale.country}/${locale.language}${breadcrumbGenderCategoryUrl}`}
            title={genderMessageIntlFormatted}
            index={0}
          />
        )}
        {breadcrumbSilhouetteCategory && breadcrumbSilhouetteCategoryUrl && (
          <BreadcrumbItem
            url={`/${locale.country}/${locale.language}${breadcrumbSilhouetteCategoryUrl}`}
            title={breadcrumbSilhouetteCategory}
            index={1}
          />
        )}
      </ol>
    </div>
  );
};

export default BreadCrumbs;
